import { app } from "../config/firebase";
import {
  collection,
  query,
  where,
  getDocs,
  getFirestore,
  doc,
  setDoc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  getAuth,
  deleteUser
} from "firebase/auth";

const db = getFirestore(app)

const auth = getAuth();

const colecao = process.env.REACT_APP_DB

export const useFirestore = () => ({
  // login
  signin: async (email, password) => {
    let result
    await signInWithEmailAndPassword(auth, email, password)
      .then((userCredencial) => {
        result = userCredencial.user
      })
      .catch(error => {
        result = error
      });
    return result
  },
  getUser: () => {
    return auth.currentUser
  },
  buscaUsers: async () => {
    const q = query(collection(db, 'users'))
    const querySnapshot = await getDocs(q)
    const users = []

    querySnapshot.forEach((doc) => users.push(doc.data()))

    return users
  },
  criaUser: async (docData) => {
    createUserWithEmailAndPassword(auth, docData.email, docData.pass)
      .then((userCredencial) => {
        docData.uid = userCredencial.user.uid
        setDoc(doc(db, 'users', userCredencial.user.uid), docData)
          .then(() => docData)
          .catch((e) => { throw new Error(e) })
      })
      .catch((e) => {
        throw new Error(e)
      })
  },
  editaUser: async (docData) => {
    updateDoc(doc(db, 'users', docData.uid), docData)
      .then(() => {
        return docData
      })
      .catch((e) => {
        throw new Error(e.code)
      })
  },
  apagaUser: async (user) => {
    signInWithEmailAndPassword(auth, user.email, user.pass)
      .then((userCredencial) => {
        deleteUser(userCredencial.user)
          .then(() => {
            deleteDoc(doc(db, 'users', user.uid))
          })
          .catch((e) => {
            throw new Error(e)
          })
      })
      .catch(e => {
        throw new Error(e)
      });
  },
  novoRelato: async (docData) => {
    docData.uuid = geraProtocolo()
    docData.criadoEm = new Date().getTime()
    docData.alteradoEm = new Date().getTime()
    docData.expiraEm = diaExpiracao(docData.alteradoEm)
    docData.status = "NOVO"

    if (docData.relato !== undefined && docData.relato !== '') {
      return await setDoc(doc(db, colecao, docData.uuid), docData).then(() => docData)
    } else {
      throw new Error('Relato em branco!')
    }
  },
  atualizaRelato: async (docData) => {
    docData.alteradoEm = new Date().getTime()
    docData.expiraEm = diaExpiracao(docData.alteradoEm)

    await updateDoc(doc(db, colecao, docData.uuid), docData)
    return (docData)
  },
  buscaRelatos: async () => {
    const q = query(collection(db, colecao))
    const querySnapshot = await getDocs(q)
    const relatos = []

    querySnapshot.forEach((doc) => relatos.push(doc.data()))

    return relatos.sort((a, b) => new Date(b.criadoEm).getTime() - new Date(a.criadoEm).getTime())
  },
  apagaRelato: async (uuid) => {
    await deleteDoc(doc(db, colecao, uuid))
    return 'Relato apagado'
  },
  buscaRelatoPeloUuid: async (uuid) => {
    const q = query(collection(db, colecao), where('uuid', '==', uuid))
    const querySnapshot = await getDocs(q)

    let relato
    querySnapshot.forEach((doc) => relato = doc.data())
    if (relato !== undefined) {
      return relato
    } else {
      throw new Error('Não foi possível encontrar seu relato, favor verifique se numero do protocolo está correto.')
    }
  },
  marcarComoLido: async (docData) => {
    docData.lido = true
    await updateDoc(doc(db, colecao, docData.uuid), docData)
    return (docData)
  },
  marcarComoNaoLido: async (docData) => {
    docData.lido = false
    await updateDoc(doc(db, colecao, docData.uuid), docData)
    return (docData)
  },
  buscaRelatorios: async () => {
    const q = query(collection(db, colecao))
    const querySnapshot = await getDocs(q)
    const relatos = []

    querySnapshot.forEach((doc) => relatos.push(higieniza(doc.data())))

    return relatos
  }
})

const higieniza = (doc) => {
    const relato = {
      //data, horário, protocolo, motivo, classificação, grau de violação, descrição, status.
      data: new Date(doc.criadoEm).toLocaleString(),
      protocolo: doc.uuid,
      motivo: doc.motivo,
      violacao: doc.gravidade != null ? doc.gravidade : null,
      descricao: doc.relato,
      status: doc.status
    }

    return relato
}


const diaExpiracao = ( data ) => {
  const dias = new Date(data)
  dias.setDate(dias.getDate() + 15)
  return dias.getTime()
}

const geraProtocolo = () => {
  const caracteres = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let protocolo = '';
  for (let i = 0; i < 8; i++) {
      const randomIndex = Math.floor(Math.random() * caracteres.length);
      protocolo += caracteres[randomIndex];
  }
  return protocolo;
}